/*
* Additional logic for Klaviyo subscribe flow (for saving local storage info o form submit)
*/
$(function () {
  var $form = $('.klaviyo_subscription_form');
  var $popup = $('.js-floating-popup');
  var formSubmittedKey = $popup.data('form-submitted-key');
  var $window = $(window);
  var $popupContainer = $('.js-floating-popup-container');
  var $popup = $('.js-floating-popup');
  var $popupNavButton = $('.js-popup-nav-button');
  var $closePopup = $('.js-close-floating-popup');
  var $showPopupToggle = $('.js-show-floating-popup');
  var modalId = $popup.data('modal-id');
  var modalOptions = {
    delay_seconds: 0.01, 
    hide_form_on_success: true, 
    ignore_cookie: true, 
    success_message: false
  }
  var $closeForm = $('.klaviyo_close_modal');
  var modalAutoLoadDelay = parseInt($popup.data('auto-load-delay-in-seconds')) * 1000; // multiple by 1k to get in ms
  var formSubmittedKey = $popup.data('form-submitted-key');
  var formHiddenKey = $popup.data('form-hidden-key');
  var bannerHiddenKey = $popup.data('banner-hidden-key');
  var timeoutId;
  var breakpoint = 1460;
  var fixedClass = 'is-fixed';
  var headerId = '#shopify-section-header';

  /**
   * Trigger click on popup
   */
  function triggerClickOnPopup () {
    KlaviyoSubscribe.attachToModalForm(modalId, modalOptions);
  }

  /**
   * Close floating popup
   * @param {object} e
   */
  function close (e) {
    e.preventDefault();

    $popup.slideUp(200, function () {
      $(this).remove();
    });

    if ($window.width() >= breakpoint) {
      $popupNavButton.fadeOut(200, function () {
        $(this).remove();
      });
    }

    window.sessionStorage.setItem(bannerHiddenKey, 'true');
    window.sessionStorage.setItem(formHiddenKey, 'true');
  }

  /**
   * Close form
   * @param {object} e
   */
  function closeForm(e) {
    window.sessionStorage.setItem(formHiddenKey, 'true');
  }

  /**
   * Stop timeout
   */
  function stopTimeout() {
    clearTimeout(timeoutId);
  }

  /**
   * Init discount elements
   */
  function initElementsVisibility() {
    var isFormSubmitted = window.localStorage.getItem(formSubmittedKey) === 'true' ? true : false ;
    var isFormHiddenForThisSession = window.sessionStorage.getItem(formHiddenKey) === 'true' ? true : false;
    var isBannerHidenForThisSession = window.sessionStorage.getItem(bannerHiddenKey) === 'true' ? true : false;

    // If form already submitted or hidden for the current browser session - don't show elements
    if (isFormSubmitted || isBannerHidenForThisSession) {
      return;
    }

    // Else show the popup(s)
    handleElementsVisibility();

    // Init delayed popup if not hidden for current browser session
    if (isFormHiddenForThisSession) {
      return;
    }

    timeoutId = setTimeout(function() {
      triggerClickOnPopup();
    }, modalAutoLoadDelay);
  }

  function handleScroll() {
    var windowWidth = $window.width();
    var scrollTop = $window.scrollTop();
    var headerHeight = $(headerId).outerHeight();
    var isBannerHidenForThisSession = window.sessionStorage.getItem(bannerHiddenKey) === 'true' ? true : false;

    if (isBannerHidenForThisSession) {
      return;
    }

    if (windowWidth < breakpoint) {
      if (scrollTop >= headerHeight) {
        $popupContainer.addClass(fixedClass);
      } else {
        $popupContainer.removeClass(fixedClass);
      }
    } else {
      if (scrollTop >= headerHeight) {
        $popup.slideDown();
      } else {
        $popup.slideUp();
      }
    }
  }

  function handleElementsVisibility() {
    var windowWidth = $window.width();
    var scrollTop = $window.scrollTop();
    var headerHeight = $(headerId).outerHeight();
    var isBannerHidenForThisSession = window.sessionStorage.getItem(bannerHiddenKey) === 'true' ? true : false;

    if (isBannerHidenForThisSession) {
      return;
    }

    if (windowWidth < breakpoint) {
      if (scrollTop >= headerHeight) {
        $popup.slideDown();
        $popupContainer.addClass(fixedClass);
      } else {
        $popup.slideDown();
      }
      
      $popupNavButton.hide();
    } else {
      if (scrollTop >= headerHeight) {
        $popup.slideDown();
      } else {
        $popup.slideUp();
      }

      $popupNavButton.show();
    }

    // Init resize events
    $window.on('scroll', handleScroll);
    $window.on('resize', debounce(handleElementsVisibility, 200));
  }

  // https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_debounce
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);
      if (immediate && !timeout) func.apply(context, args);
    };
  }

  /**
   * Mark form as completed in the local storage
   */
  function saveInfoAboutTheSubmittedForm() {
    window.localStorage.setItem(formSubmittedKey, 'true');
  }

  // Init
  initElementsVisibility();
  $closePopup.on('click', close);
  $closeForm.on('click', closeForm);
  $showPopupToggle.on('click', stopTimeout);
  $form.on('klaviyo.subscribe.success', saveInfoAboutTheSubmittedForm);
});
